/**
 * 自动控制所有接口是否展示全局加载中动图
 * @author haoru
 */

import store from '@/pure-store';

// const DEBUG_LOG = process.env.NX_APP_ENV !== 'prod';
const DEBUG_LOG = false;
class GlobalLoading {
  private static instance: null | GlobalLoading;

  // 执行中的请求数
  private requestCount = 0;

  private log(...args) {
    DEBUG_LOG &&
      // eslint-disable-next-line no-console
      console.log(
        performance.now(),
        ...args,
        `requestCount=${this.requestCount}`
      );
  }

  public removeRequestCount(url?: string) {
    this.requestCount -= 1;
    this.syncRequestCountToStore();
    this.log('removeRequest', url);
  }

  public addRequestCount(url?: string) {
    this.requestCount += 1;
    this.syncRequestCountToStore();
    this.log('addRequest', url);
  }

  public syncRequestCountToStore() {
    store.dispatch({
      type: 'common/updateState',
      payload: {
        loading: this.requestCount > 0
      }
    });
  }

  public static getInstance() {
    if (!GlobalLoading.instance) {
      GlobalLoading.instance = new GlobalLoading();
    }
    return GlobalLoading.instance;
  }
}

export default GlobalLoading.getInstance();
